const TextField = {
	MuiTextField: {
		styleOverrides: {
			root: {
				width: '100%',
			},
		},
	},
}

export default TextField
